import {SortOrder} from '../sort-order';

export class SubscriptionFilters {
  username: string;
  startDate: number;
  endDate: number;
  serialNumber: string;
  active: boolean;
  organizationUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
